<template>
  <div id="c-mobile-appbar" class="c-mobile-appbar">
    <div class="appbar-links">
      <!-- Заявки -->
      <n-link
          :class="routeName === 'mobile.transactions' ? 'appbar-link active' : 'appbar-link'"
          :to="{ name: 'mobile.transactions' }"
      >
        <div class="link-content">
          <div class="icon">
            <img :src="routeName === 'mobile.transactions' ? historyActive : history" alt="История снятий" />
          </div>
          <span>История снятий</span>
        </div>
      </n-link>

      <!-- Заявки -->
      <n-link
          :class="routeName === 'mobile.index' ? 'appbar-link active' : 'appbar-link'"
          :to="{ name: 'mobile.index' }"
      >
        <div class="link-content">
          <div class="icon">
            <img :src="routeName === 'mobile.index' ? chartsActive : charts" alt="Заявки" />
          </div>
          <span>Заявки</span>
        </div>
      </n-link>

      <!-- Вывод средств -->
      <n-link
          :class="routeName === 'mobile.payment' ? 'appbar-link active' : 'appbar-link'"
          :to="{ name: 'mobile.payment' }"
      >
        <div class="link-content">
          <div class="icon">
            <img :src="routeName === 'mobile.payment' ? getMoneyActive : getMoney" alt="Вывод средств" />
          </div>
          <span>Вывод средств</span>
        </div>
      </n-link>

      <n-link
          class="appbar-link-logout"
          @click="$app.auth.logout()"
      >
        <div class="link-content">
          <div class="icon">
            <img :src="logoutIcn" alt="Выход" />
          </div>
          <span>Выход</span>
        </div>
      </n-link>
    </div>
  </div>
</template>

<script>
import charts from "assets/mobile-appbar/chart.svg"
import history from "assets/history.svg"
import historyActive from "assets/history-active.svg"
import logoutIcn from "assets/logoun.svg"
import chartsActive from "assets/mobile-appbar/chart-active.svg"
import imgUser from "assets/mobile-appbar/user.svg"
import imgHome from "assets/mobile-appbar/home.svg"
import getMoney from "assets/mobile-appbar/get-money.svg"
import getMoneyActive from "assets/mobile-appbar/get-money-active.svg"
import imgTimeTracker from "assets/mobile-appbar/mobile-time-tracker.svg"
import { Capacitor } from "@capacitor/core"

export default {
  name: "CMobileAppbar",
  data() {
    return {
      imgHome,
      logoutIcn,
      imgUser,
      getMoney,
      getMoneyActive,
      charts,
      chartsActive,
      history,
      historyActive,
      imgTimeTracker,
      isMobile: false,
    }
  },
  computed: {
    routeName() {
      return this.$route.name
    },
    count() {
      return this.$store.state.app.count
    },
    showBtn() {
      return this.$store.state.app.isShowBtnPayment 
    }
  },
  watch: {},
  created() {
    if (Capacitor.getPlatform() !== 'web') {
      this.isMobile = true
    }
  },
  mounted() {
    document.getElementById('c-mobile-appbar').style.paddingBottom = Capacitor.getPlatform() === 'ios' && '10px'
  },
  methods: {},
}
</script>

<style lang="scss" scoped>
.c-mobile-appbar {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  height: 64px;
  background-color: #fff;
  box-shadow: 0 -2px 12px rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  transition: all 0.3s ease-in-out;
  border-top-left-radius: 16px;
  border-top-right-radius: 16px;
}

.appbar-links {
  display: flex;
  justify-content: space-around;
  width: 100%;
  max-width: 480px;
  padding: 0 16px;
}

.appbar-link {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: #888;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  padding: 8px 12px;
  border-radius: 12px;
}

.appbar-link-logout {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-decoration: none;
  color: red;
  font-size: 12px;
  font-weight: 500;
  transition: all 0.2s ease-in-out;
  padding: 8px 12px;
  border-radius: 12px;
}

.appbar-link-logout .icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
  transition: transform 0.2s ease;
}

.appbar-link .icon {
  width: 24px;
  height: 24px;
  margin-bottom: 4px;
  transition: transform 0.2s ease;
}

.appbar-link span {
  display: block;
  text-align: center;
}

.appbar-link:hover {
  background-color: rgba(0, 122, 255, 0.1);
  transform: translateY(-2px);
}

.appbar-link-logout:hover {
  background-color: rgba(255, 59, 48, 0.12); /* iOS red */
  color: #ff3b30;
  transform: translateY(-2px);
}

.appbar-link:active {
  transform: translateY(0);
}

.appbar-link.active {
  color: #007aff;
}

.appbar-link.active .icon {
  transform: scale(1.2);
}

.link-content {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>

